// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","counterWrap":"_2womw73rQCDI4jErDCUyNX","number":"_3Jh9VUpatjCFtwL2ucaDVo","small":"_1r2UuVGIvaC8GmFiYyBhAq","text":"iVr3kaI0Yizx5qu0Dy_DU"};